'use strict';

var Search = 'Goals';
var selectors = {
	productSection: document.querySelector('#shopify-section-static-product'),
	dataEl: null,
	accordion: document.querySelector('.product-description .ll-product-accordion')
};

var product = {};
var rawtags = [];

var rating = {
	headline: null,
	items: []
};

/**
 * 
 * Takes the Dataset from Shopify Template
 * Try to parse it as JSON
 * Find the Product Object and return it, or else empty
 */
function parseData(source) {
	try {
		var r = JSON.parse(source);
		if (r.product) {
			return r.product;
		}

		return {};
	} catch (error) {
		return {};
	}
};

/**
 * 
 * Filtering out all tags, that contains `Search` (Goals) 
 */
function filterTags(tags) {
	tags.map(function (tag) {
		if (tag.indexOf(Search) !== -1 && !tag.indexOf('_') !== -1) {
			rawtags.push(tag); 
		}
	});

	return;
};

/**
 * 
 * Convert all filtered tags, to objects of key/value
 */
function getRatings(stack) {

	if (!stack || stack.length > 0) {
		for (var index = 0; index < stack.length; index++) {
			var element = stack[index];
			var hay = element.split(':');

			rating.items.push({
				name: hay[1],
				value: hay[2]
			});
		}
	}

	return;
};

/**
 * 
 * Take first element, and manipulate the string to get a Headline
 */
function getHeadline(stack) {

	if (!stack || stack.length > 0) {
		var element = stack[0];

		var hay = element.split(':');

		rating.headline = hay[0].split(Search) + ' ' + Search.toLowerCase();
	}

	return;
};

/**
 * 
 * Create the HTML for the ratings
 */
function createHTML(headline, items) {
	var ratingAccordion = selectors.accordion;

	var ratingAccordionContent = ratingAccordion.querySelector(".ll-product-accordion__content");

	var headlineEl = document.createElement('h4');
	headlineEl.innerHTML = headline ? headline.replace(', ', ' ') : '';

	var ratingListEl = document.createElement('ul');
	ratingListEl.setAttribute('aria-label', headline);
	ratingListEl.className = 'll-product-rating';

	for (var i = 0; i < items.length; i++) {
		var ratingListItem = document.createElement('li');
		var ratingListItemTitle = document.createElement('div');
		ratingListItemTitle.className = 'll-product-rating-title' + ' ' + items[i].name.toLowerCase();
		ratingListItemTitle.innerHTML = items[i].name;
		ratingListItem.appendChild(ratingListItemTitle);
		var ratingListItemStars = document.createElement('div');
		ratingListItemStars.className = 'll-product-rating-stars';

		var maxRating = 5;

		for (var j = 0; j < maxRating; j++) {

			if (j < parseInt(items[i].value, 10)) {
				ratingListItemStars.innerHTML += '<span class="ll-product-star ll-product-star--filled"></span>';
			} else {
				ratingListItemStars.innerHTML += '<span class="ll-product-star"></span>';
			}
		}

		ratingListItem.appendChild(ratingListItemStars);
		ratingListEl.appendChild(ratingListItem);
	}

	ratingAccordionContent.appendChild(headlineEl);
	ratingAccordionContent.appendChild(ratingListEl);
};

function DOMReady(a, b, c) {
	b = document;
	c = 'addEventListener';
	b[c] ? b[c]('DOMContentLoaded', a) : window.attachEvent('onload', a);
};

function init() {

	if (selectors && selectors.productSection) {

		// Find Dataset, it's part of the product template
		selectors.dataEl = selectors.productSection.querySelector('[data-section-data]');

		// Eject if we didn't find any Dataset or accordions
		if (!selectors.dataEl || !selectors.accordion) {
			return;
		}

		// Parse the Dataset, as JSON
		product = parseData(selectors.dataEl.innerHTML);

		// Make sure that there's any tags on the product.
		if (!product.tags) {
			return;
		}

		filterTags(product.tags);
		if (rawtags) {
			getRatings(rawtags);
			getHeadline(rawtags);
		}

		createHTML(rating.headline, rating.items);
	}
};

// Init
DOMReady(init);